// extracted by mini-css-extract-plugin
export var back = "navigation-module--back--f6e14";
export var categoryItem = "navigation-module--categoryItem--fe2ee";
export var categoryLevel = "navigation-module--categoryLevel--5b14d";
export var close = "navigation-module--close--fda6c";
export var isFirstPanel = "navigation-module--isFirstPanel--0669b";
export var isVisible = "navigation-module--isVisible--679d9";
export var main = "navigation-module--main--f7956";
export var navigation = "navigation-module--navigation--40a39";
export var selected = "navigation-module--selected--1aa5e";